import { FaCaretDown } from "react-icons/fa";
import { Popover, OverlayTrigger } from "react-bootstrap";

const VideoHighlighter = (props:any) => {
    const item = props.item;
    const popover = (
        <Popover id="popover-basic" className="highlighter-tooltip">      
          <div className="highlighter-container px-3 py-2">
            {item.name}
          </div>
        </Popover>
    );

    return(
        <>
            <OverlayTrigger trigger={["click"]} placement="auto" overlay={popover} show={item.show}>
                <div className={`highlighter ${item.flag}-highlighter`} 
                    style={{position: 'absolute', top: (parseFloat(item.y_position)*100 +"%"), 
                    left:(parseFloat(item.x_position)*100 +"%"), display: item.show ? 'block':'none' }}
                >
                    <FaCaretDown size={20} className={`highlighter-svg ${item.flag}-highlighter-svg`} />
                </div>
            </OverlayTrigger>
                
        </>
    )
};

export default VideoHighlighter;